export default "__VITE_ASSET__Cyf1Hl3T__"